module.exports = __webpack_public_path__ + "img/IMG_2722.55840960.jpg";